export default __webpack_public_path__ + "static/media/bg.1234f65b.webp";